import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createStoreKnowledgeApi } from '../utils/apis';
import { useAlert } from './useAlert';

const useCreateStoreKnowledge = () => {
  const { showAlert } = useAlert();
  const queryClient = useQueryClient();
  const { mutate: createStoreKnowledge, isPending } = useMutation({
    mutationFn: createStoreKnowledgeApi,
    onSuccess: () => {
      showAlert('Store knowledge created successfully', 'success');
      queryClient.invalidateQueries({
        queryKey: ['stores'],
      });
    },
    onError: (error: any) => {
      showAlert(error.response.data.message, 'error');
    },
  });

  return { createStoreKnowledge, isPending };
};

export default useCreateStoreKnowledge;
